import SearchAIPrompt from "./SearchAIPrompt";
import ResultCell from "./ResultCell";

export { ResultCell };

export default SearchAIPrompt;
